// components/AttendeeDetailWrapper.js

import React, { useState } from 'react';
import AttendeeDetailDrawer from './Drawer/AttendeeDetailDrawer';
import RefundActionModal from './Modal/RefundActionModal';
import CancelByOrganizerModal from './Modal/CancelByOrganizerModal';

const AttendeeDetailWrapper = ({
  isOpen,
  onClose,
  attendee,
  onApprove,
  onReject,
  onDenyCancellation,
  onAcceptCancellation,
  onMarkRefunded,
  onCancelByOrganizer,
  anchor = 'right',
  width = '500px'
}) => {
  const [showRefundActionModal, setShowRefundActionModal] = useState(false);
  const [showCancelByOrganizerModal, setShowCancelByOrganizerModal] = useState(false);
  const [refundAction, setRefundAction] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleRefundAction = (actionType) => {
    setRefundAction(actionType);
    setShowRefundActionModal(true);
  };

  const handleCancelByOrganizerClick = () => {
    // Determinar el tipo de acción basado en el estado del asistente
    if (attendee?.status === 'attending') {
      setShowCancelByOrganizerModal(true);
    } else {
      // Para otros estados (confirmation_pending, etc.), usar onReject directamente
      onReject(attendee._id);
    }
  };

  const confirmRefundAction = async ({
    organizerMessage,
    refundAmountCents = null
  }) => {
    try {
      setIsLoading(true);
      if (refundAction === 'accept') {
        if (typeof onAcceptCancellation === 'function') {
          await onAcceptCancellation(attendee._id, refundAmountCents, organizerMessage);
        } else {
          console.error('onAcceptCancellation is not a function');
        }
      } else if (refundAction === 'deny') {
        if (typeof onDenyCancellation === 'function') {
          await onDenyCancellation(attendee._id, organizerMessage);
        } else {
          console.error('onDenyCancellation is not a function');
        }
      }
      setShowRefundActionModal(false);
      setRefundAction(null);
      // No cerrar el drawer, permitir que se actualice con los nuevos datos
    } catch (error) {
      console.error('Error en confirmRefundAction:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmCancelByOrganizer = async (attendeeId, refundAmount, organizerMessage) => {
    try {
      setIsLoading(true);
      await onCancelByOrganizer(attendeeId, refundAmount, organizerMessage);
      setShowCancelByOrganizerModal(false);
      // No cerrar el drawer, permitir que se actualice con los nuevos datos
    } catch (error) {
      console.error('Error al cancelar inscripción:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AttendeeDetailDrawer
        isOpen={isOpen}
        onClose={onClose}
        attendee={attendee}
        onApprove={onApprove}
        onReject={onReject}
        onRefundAction={handleRefundAction}
        onCancelByOrganizerClick={handleCancelByOrganizerClick}
        onMarkRefunded={onMarkRefunded}
        anchor={anchor}
        width={width}
        isLoading={isLoading}
      />

      <RefundActionModal
        isOpen={showRefundActionModal}
        onClose={() => {
          setShowRefundActionModal(false);
          setRefundAction(null);
        }}
        onConfirm={confirmRefundAction}
        actionType={refundAction}
        attendee={attendee}
        isLoading={isLoading}
      />

      <CancelByOrganizerModal
        isOpen={showCancelByOrganizerModal}
        onClose={() => setShowCancelByOrganizerModal(false)}
        onConfirm={confirmCancelByOrganizer}
        attendee={attendee}
        isLoading={isLoading}
      />
    </>
  );
};

export default AttendeeDetailWrapper;
